/** Split date/time for iOS Telegram WebView (datetime-local often hides time). */

export function splitDueLocal(isoOrLocal: string): { date: string; time: string } {
  const d = new Date(isoOrLocal);
  if (Number.isNaN(d.getTime())) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return { date: toDateInput(tomorrow), time: '18:00' };
  }
  return { date: toDateInput(d), time: toTimeInput(d) };
}

export function mergeDueLocal(date: string, time: string): string {
  if (!date) return '';
  const t = time && /^\d{2}:\d{2}$/.test(time) ? time : '18:00';
  const d = new Date(`${date}T${t}:00`);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString();
}

export function defaultDueParts(): { date: string; time: string } {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(18, 0, 0, 0);
  return { date: toDateInput(d), time: '18:00' };
}

function toDateInput(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function toTimeInput(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

type Props = {
  value: string;
  onChange: (iso: string) => void;
  disabled?: boolean;
  dateClassName?: string;
  timeClassName?: string;
};

/** Date + time as separate inputs — works in Telegram WebView on iOS. */
export function CrmTaskDueFields({
  value,
  onChange,
  disabled,
  dateClassName = 'input-glass flex-1 text-sm min-h-[40px] touch-manipulation',
  timeClassName = 'input-glass w-[5.5rem] shrink-0 text-sm min-h-[40px] touch-manipulation text-center',
}: Props) {
  const { date, time } = splitDueLocal(value);

  const emit = (nextDate: string, nextTime: string) => {
    if (!nextDate) return;
    onChange(mergeDueLocal(nextDate, nextTime));
  };

  return (
    <div className="flex gap-2 w-full min-w-0">
      <input
        type="date"
        className={dateClassName}
        value={date}
        disabled={disabled}
        onChange={(e) => emit(e.target.value, time)}
      />
      <input
        type="time"
        className={timeClassName}
        value={time}
        disabled={disabled}
        step={300}
        onChange={(e) => emit(date, e.target.value)}
      />
    </div>
  );
}
